// eslint-disable-next-line @typescript-eslint/no-var-requires
export default require("../package.json").version;
